"use client"

import * as React from "react"

import { cn } from "./utils"

function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "inline-flex h-6 items-center rounded-md border border-border-default bg-bg-secondary px-2 font-mono text-[11px] font-medium text-text-secondary",
        className
      )}
      {...props}
    />
  )
}

export { Kbd }
